import { useEffect, useRef } from 'react';

import {
  HAMBURGER_MENU_STORAGE_KEY,
  HAMBURGER_MENU_URL_PARAM,
  HAMBURGER_MENU_URL_PARAM_OFF_VALUE,
} from '#/layouts/Layout/Header/HamburgerMenu/useIsHamburgerMenuEnabled';
import {
  removeLocalStorageItem,
  setLocalStorageRawItem,
} from '#/utils/localStorage';

/**
 * `?experiment_hamburger` persists the hamburger menu flag in localStorage,
 * `?experiment_hamburger=0` clears it
 */
// TODO(@paprikka): temporary toggle, drop once sc-68335 is ready to be deployed
export function EnableHamburgerMenuWithUrlParamGlobalHandler() {
  const triggeredRef = useRef(false);

  useEffect(() => {
    if (triggeredRef.current) return;
    triggeredRef.current = true;

    const value = new URLSearchParams(window.location.search).get(
      HAMBURGER_MENU_URL_PARAM,
    );
    if (value === null) return;

    if (value === HAMBURGER_MENU_URL_PARAM_OFF_VALUE) {
      removeLocalStorageItem(HAMBURGER_MENU_STORAGE_KEY);
      return;
    }

    setLocalStorageRawItem(HAMBURGER_MENU_STORAGE_KEY, '1');
  }, []);

  return null;
}
